import { 
  Injectable, 
} from "@angular/core"; 

import { 
  HttpClient, 
} from "@angular/common/http"; 

import { 
  Observable, 
} from "rxjs"; 

import { 
  HUserAffiliationMapping_ReadByHospitalId, 
  Roles_ReadAllPaginated, 
  SchoolMaster_ReadAllPaginated, 
  SmUserAffiliationMapping_ReadBySocietyId, 
  Society_ReadAllPaginated, 
  SUserAffiliationMapping_ReadBySchoolId, 
  SubRoles_readByUserId, 
  SubRoles_update, 
  UserMaster_ReadAllPaginated, 
} from "src/app/GlobalVariable"; 

import { 
  HospitalMaster_ReadAllPaginated, 
} from "src/app/GlobalVariable/Hospital.GlobalVariable"; 

import { 
  SubRoleReadByUserIdRequestDTO, 
  SubRoleUpdateRequestDTO, 
  UserMenuModuleName, 
} from "./usermenu-config-interface"; 




@Injectable({ 
  providedIn: "root", 
}) 
export class UsermenuConfigService { 

  constructor( 
    private http: 
      HttpClient, 
  ) {} 


  // ============================================================ 
  // ONBOARDED ENTITY 
  // ============================================================ 

  readModuleEntities( 
    moduleName: 
      UserMenuModuleName, 
  ): Observable<any> { 

    const request = { 
      pageSize: 1000, 
      pageNo: 1, 
      whereClause: null, 
      orderByClause: null, 
    }; 


    if ( 
      moduleName === "School" 
    ) { 

      return this.http.post<any>( 
        SchoolMaster_ReadAllPaginated, 
        request, 
      ); 
    } 


    if ( 
      moduleName === "Hospital" 
    ) { 

      return this.http.post<any>( 
        HospitalMaster_ReadAllPaginated, 
        request, 
      ); 
    } 


    if ( 
      moduleName === "Society" 
    ) { 

      return this.http.post<any>( 
        Society_ReadAllPaginated, 
        request, 
      ); 
    } 


    return this.http.post<any>( 
      UserMaster_ReadAllPaginated, 
      request, 
    ); 
  } 


  // ============================================================ 
  // USER AFFILIATION LIST 
  //
  // MINIMUM FIX:
  // After selecting onboarded School / Hospital / Society,
  // call Roles_ReadAllPaginated.
  //
  // Component filters Roles.ModuleName + Roles.ModuleId and
  // reads Roles.AffiliationType for the User Affiliation dropdown.
  // ============================================================ 

  readAffiliationRoles(): Observable<any> { 

    const request = { 
      pageSize: 1000, 
      pageNo: 1, 
      whereClause: null, 
      orderByClause: "A.RoleName ASC", 
    }; 


    return this.http.post<any>( 
      Roles_ReadAllPaginated, 
      request, 
    ); 
  } 


  // ============================================================ 
  // USERS BY SELECTED MODULE ENTITY 
  //
  // IMPORTANT:
  // Do not use ReadUserBySchoolId here for this admin config page.
  // That API validates the logged-in user's school affiliation and
  // causes "User is not affiliated with the specified School"
  // for Module Config users.
  //
  // ReadBySchoolId / ReadByHospitalId / ReadBySocietyId returns
  // the affiliation records for the selected onboarded entity.
  // Component then filters them by selected AffiliationType.
  // ============================================================ 

  readUsersByModuleEntity( 
    moduleName: 
      UserMenuModuleName, 
    moduleId: 
      number, 
  ): Observable<any> { 

    if ( 
      moduleName === "School" 
    ) { 

      return this.http.post<any>( 
        SUserAffiliationMapping_ReadBySchoolId, 
        { 
          schoolId: 
            Number(moduleId), 
        }, 
      ); 
    } 


    if ( 
      moduleName === "Hospital" 
    ) { 

      return this.http.post<any>( 
        HUserAffiliationMapping_ReadByHospitalId, 
        { 
          hospitalId: 
            Number(moduleId), 
        }, 
      ); 
    } 


    if ( 
      moduleName === "Society" 
    ) { 

      return this.http.post<any>( 
        SmUserAffiliationMapping_ReadBySocietyId, 
        { 
          societyId: 
            Number(moduleId), 
        }, 
      ); 
    } 


    const request = { 
      pageSize: 1000, 
      pageNo: 1, 
      whereClause: null, 
      orderByClause: null, 
    }; 


    return this.http.post<any>( 
      UserMaster_ReadAllPaginated, 
      request, 
    ); 
  } 


  // ============================================================ 
  // USER ASSIGNED MENUS 
  // ============================================================ 

  readAssignedMenusByUserId( 
    request: 
      SubRoleReadByUserIdRequestDTO, 
  ): Observable<any> { 

    return this.http.post<any>( 
      SubRoles_readByUserId, 
      request, 
    ); 
  } 


  // ============================================================ 
  // SUB ROLE UPDATE 
  // ============================================================ 

  updateSubRole( 
    request: 
      SubRoleUpdateRequestDTO, 
  ): Observable<any> { 

    return this.http.post<any>( 
      SubRoles_update, 
      request, 
    ); 
  } 
} 
